import { render, staticRenderFns } from "./ReleasesList.vue?vue&type=template&id=3236ea07&scoped=true&"
import script from "./ReleasesList.vue?vue&type=script&lang=js&"
export * from "./ReleasesList.vue?vue&type=script&lang=js&"
import style0 from "./ReleasesList.vue?vue&type=style&index=0&id=3236ea07&lang=scss&scoped=true&"
import style1 from "./ReleasesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3236ea07",
  null
  
)

export default component.exports